import * as v2 from './chatV2';
import * as v3 from './chatV3';

const adapters = {
    2: {
        engineVersion: 2,
        start: v2.startChatV2Thread,
        getPublicExamples: v2.getPublicChatExamples,
        getSuggestions: v2.getChatV2Suggestions,
        deleteSuggestion: v2.deleteChatV2Suggestion,
        getThread: v2.getChatV2Thread,
        getSharedThread: v2.getSharedChatV2Thread,
        sendMessage: v2.sendChatV2Message,
        getStatusRef: v2.getChatV2RunPublicStatusRef,
        share: v2.shareChatV2Thread,
        unshare: v2.unshareChatV2Thread,
        delete: v2.deleteChatV2Thread,
        threadPath: (id) => `/chat_thread/${encodeURIComponent(id)}`,
        publicPath: (id) => `/public_chat_thread/${encodeURIComponent(id)}`,
    },
    3: {
        engineVersion: 3,
        start: v3.startChatV3Thread,
        getPublicExamples: v3.getWebPublicChatExamples,
        getSuggestions: v3.getWebChatSuggestions,
        deleteSuggestion: v3.deleteWebChatSuggestion,
        getThread: v3.getChatV3Thread,
        getSharedThread: v3.getSharedChatV3Thread,
        sendMessage: v3.sendChatV3Message,
        getStatusRef: v3.getChatV3RunPublicStatusRef,
        share: v3.shareChatV3Thread,
        unshare: v3.unshareChatV3Thread,
        delete: v3.deleteChatV3Thread,
        threadPath: (id) => `/chat_v3_thread/${encodeURIComponent(id)}`,
        publicPath: (id) => `/public_chat_v3_thread/${encodeURIComponent(id)}`,
    },
};

export const getChatAdapter = (version = 2) => {
    const adapter = adapters[version];
    if (!adapter) throw new Error('Unsupported conversation version.');
    return adapter;
};

// Build-time rollback changes only new questions and cached homepage examples.
// Existing conversations always select their adapter from their versioned URL.
export const getDefaultChatAdapter = () => getChatAdapter(
    process.env.REACT_APP_CHAT_DEFAULT_VERSION === '2' ? 2 : 3,
);

export const chatThreadKey = (thread) => `${thread.engineVersion || 2}:${thread.threadId}`;

// Home/Ask is mounted above the routes. Keep the draft and visible pair while
// invalidating its personal pool after a conversation changes.
export const CHAT_SUGGESTIONS_CHANGED = 'podeux-chat-suggestions-changed';
const publicationRefreshTimers = new Set();
export const invalidateChatSuggestions = ({ afterPublication = false } = {}) => {
    const notify = () => window.dispatchEvent(new Event(CHAT_SUGGESTIONS_CHANGED));
    notify();
    if (!afterPublication) return;
    // Suggestion publication is asynchronous. Retry invalidation briefly; the
    // provider only reads while Home/Ask is active and still coalesces requests.
    publicationRefreshTimers.forEach((timer) => window.clearTimeout(timer));
    publicationRefreshTimers.clear();
    [1500, 5000].forEach((delay) => {
        const timer = window.setTimeout(() => {
            publicationRefreshTimers.delete(timer);
            notify();
        }, delay);
        publicationRefreshTimers.add(timer);
    });
};
